import { Dimensions, Positions } from './types'

export const dimensionFromPosition = (position: Positions): Dimensions => {
	switch (position) {
		case 'top':
		case 'bottom':
			return 'height'
		case 'left':
		case 'right':
			return 'width'
	}
}

export const cross = (axis: Dimensions): Dimensions => (axis === 'height' ? 'width' : 'height')
